<template>
  <div class="questions d-flex justify-content-between flex-column">
    <template v-if="state==1 && !isShowDoctorFind">
      <h2>{{poll.name}}</h2>
      <div class="questions__body" v-html="poll.text">
      </div>
      <div>
        <button-component @click="startPoll">Пройти тест</button-component>
      </div>
    </template>

    <template v-if="state==2 && !isShowDoctorFind">
      <template class="d-flex justify-content-center flex-column" v-if="poll.items && poll.items.length > 0">
        <div class="d-flex justify-content-center flex-wrap align-items-center h-100"
             v-if="currentQuestion==poll.items.length">
          <button-component class="mx-2" @click="save">Получить результаты теста</button-component>
          <button-component class="mx-2" kind="secondary" @click="exit">Выйти</button-component>
        </div>
        <div class="d-flex justify-content-between flex-column flex-grow-1" v-else>
          <div>
            <h4>{{ poll.items[currentQuestion].name }}</h4>
            <div>
              <p>
                {{ poll.items[currentQuestion].comment }}
              </p>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap justify-content-center justify-content-sm-between">
            <div class="d-flex align-items-center flex-wrap">
              <button-component class="m-2" @click="nextQuestion(false)">Нет</button-component>
              <button-component class="m-2" @click="nextQuestion(true)">Да</button-component>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <button-component class="m-2" kind="secondary" @click="prevQuestion" v-if="currentQuestion>0">К
                предыдущему вопросу
              </button-component>
              <button-component class="m-2" kind="secondary" @click="exit">Выйти</button-component>
            </div>

          </div>
        </div>
      </template>
      <template v-else>
        Загрузка теста...
      </template>

    </template>

    <template v-if="state >= 3 && !isShowDoctorFind">
      <div>
        <h3>{{poll.resultTitle}}</h3>

        <div>
          <!-- РЕЗУЛЬТАТ ТЕСТА:  -->
          <span v-if="isHighRisk">ВЫСОКИЙ РИСК</span>
          <span v-if="isLowRisk">НИЗКИЙ РИСК</span>
          <span v-if="isMidRisk">СРЕДНИЙ РИСК</span>
        </div>

        <template v-if="isShowDetail">
          <div v-if="isHighRisk">
            <!-- <span>ВЫСОКИЙ РИСК.</span> -->
            {{poll.highRiskText}}
          </div>

          <div v-if="isLowRisk">
            <!-- <span>НИЗКИЙ РИСК.</span> -->
            {{poll.lowRiskText}}
          </div>

          <div v-if="isMidRisk">
            <!-- <span>СРЕДНИЙ РИСК.</span> -->
            {{poll.mediumRiskText}}
          </div>

          <div v-if="isHighRisk || isMidRisk">

            <div v-if="state == 3">
              <!-- форма для заполнения -->
              <h4 class="mt-4">Данные ребенка</h4>
              <div class="row d-flex flex-wrap flex-column flex-sm-row mb-4">
                <div class="form-group col col-md-3  required">
                  <component-input
                      placeholder="Введите фамилию"
                      label="Фамилия" required :maxLength="50"
                      v-model="item.surname"/>
                </div>

                <div class="form-group col col-md-3 required">
                  <component-input
                      placeholder="Введите имя"
                      label="Имя" required :maxLength="50"
                      v-model="item.name"/>
                </div>


                <div class="form-group col col-md-3">
                  <component-input
                      placeholder="Введите отчество"
                      label="Отчество" :maxLength="50"
                      v-model="item.patronimic"/>
                </div>
              </div>
              <div class="row mb-4">
                <div class="form-group col col-md-3 required">
                  <label class='control-label'>Дата рождения</label>
                  <div>
                    <date-component  :disabled="false" v-model="item.dateOfBirth" required/>
                  </div>
                </div>
                <div class="form-group col col-md-3 required">
                  <label class='control-label'>Дата заполнения</label>
                  <div>
                    <date-component  :disabled="true" v-model="item.created" required/>
                  </div>
                </div>
                <div class="form-group col col-md-3 select2 required">
                  <label class='control-label'>Район проживания</label>
                      <Select2
                          placeholder="Не указано"
                          :options="districtList"
                          v-model="item.addressDistrictId"/>
                  <div class="invalid-msg" v-if="v$.item.addressDistrictId.$error">Поле обязательно для заполнения</div>
                  <!-- <label class='control-label'>Район проживания</label>
                  <div>
                    <component-input
                        label="Район"
                        type="select2"
                        required
                        :select2Options="districtList"
                        :select2Settings="select2Settings"
                        v-model="item.addressDistrictId"
                    />
                  </div> -->

                </div>
                
              </div>

              <div class="row mb-4 border-bottom pb-4">
                <div class="form-group col col-md-9 required">
                  <component-input
                      placeholder="Введите адрес проживания"
                      label="Адрес проживания" :maxLength="500"
                      v-model="item.address" required />
                </div>
              </div>

              <div class="border-bottom mb-4">
                <h4>Законный представитель</h4>
                <div v-for="(repres, index) in item.tmpRepresentatives"
                    :key="repres.id"
                >
                  <button-component class="btn mb-4" kind="secondary" v-if="index > 0" v-on:click="deleteRepres(repres)">
                    Удалить
                  </button-component>
                  <div class="row flex-wrap flex-column flex-sm-row mb-4">
                    <div class="form-group col col-md-3 required">
                      <component-input
                          placeholder="Введите фамилию"
                          label="Фамилия" required :maxLength="50"
                          v-model="repres.surname"/>
                    </div>

                    <div class="form-group col col-md-3 required">
                      <component-input
                          placeholder="Введите имя"
                          label="Имя" required :maxLength="50"
                          v-model="repres.name"/>
                    </div>


                    <div class="form-group col col-md-3">
                      <component-input
                          placeholder="Введите отчество"
                          label="Отчество" :maxLength="50"
                          v-model="repres.patronimic"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col col-md-3  select2 required mb-4">
                      <label class='control-label'>Степень родства</label>
                      <Select2
                          placeholder="Не указано"
                          :options="relationTypeList"
                          v-model="repres.relationTypeId"/>
                    </div>
                    <div class="form-group col col-md-3 required mb-4">
                      <component-input
                          type="phone"
                          label="Контактный телефон" required
                          v-model="repres.phone"/>
                    </div>
                  </div>

                </div>

  <!--              <button-component kind="secondary" class="btn mb-4" @click="addRepres">Добавить еще</button-component>-->
              </div>

              <div class="row mb-4 px-3">
                <div class="form-check required">
                  <input type="checkbox" class="form-check-input" v-model="item.isAgree" id="chkIsAgree">
                  <label for="chkIsAgree" class="form-check-label control-label">Согласие на обработку персональных
                    данных</label>
                  <a class="mx-2" href="/consent.pdf" download="СОГЛАСИЕ на персон.данныx.pdf">скачать</a>
                  <div class="invalid-msg" v-if="v$.item.isAgree.$error">
                    Поле обязательно для заполнения
                  </div>
                </div>
              </div>

              <button-component class="btn" @click="saveTmpPatient">Отправить</button-component>
            </div>


          </div>
        </template>


      </div>
      <!-- <div  v-if="state == 4">
        <button-component @click="loadResultFile">Скачать результаты тестирования</button-component>
      </div> -->

      <div v-if="state >= 3" class="d-flex flex-wrap align-items-center">
          <!-- кнопки -->
          <button-component class="mr-2" @click="detailInfo" v-if="(isHighRisk || isMidRisk) && !isShowDetail">Подробная информация</button-component>
          <button-component class="mr-2" @click="doctorFind" v-if="(isHighRisk || isMidRisk) && false">Записаться на прием к врачу</button-component>
          <button-component class="mr-2" @click="loadResultFile">Скачать результаты тестирования</button-component>
      </div>

    </template>

    <template v-if="isShowDoctorFind">
      <doctor-find-form @close="isShowDoctorFind=false" />
    </template>
  </div>
</template>

<script>
import API from '../api/poll'
import Constants from '@/common/constants'
//import { required } from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import ComponentInput from "@/common/components/ComponentInput";
import ButtonComponent from "../../../common/components/ButtonComponent";
import Select2 from "../../../common/ui/Select2";
import DoctorFindForm from './DoctorFindForm.vue';

const chbxChecked = (value) => value == true;
const requiredValidator = (value) => (value && (value > 0 || value == 'false' || value == 'true' || value == -1));

export default {
  name: "MChatR",
  components: {
    Select2,
    ButtonComponent,
    ComponentInput,
    DateComponent,
    DoctorFindForm
  },
  created() {
    this.loadRelationTypeList();
    this.loadDistrictList();
    this.loadPoll();
  },
  data() {
    return {
      state: 1,
      isShowDetail: false,
      isShowDoctorFind: false,
      currentQuestion: 0,
      poll: {},
      answers: {},
      result: {},

      districtList: [{id: 0, text: Constants.emptySelectOptionText, selected: true}],
      relationTypeList: [],
      item: {
        tmpRepresentatives: [{}],
        created: moment().format("YYYY-MM-DD"),
        addressDistrictId: 0
      }
    };
  },
  methods: {
    loadPoll() {
      API.getPoll().then(response => {
        //console.log(response.data, 'API.getPoll');
        response.data.text = response.data.text
                .split('\n')
                .map((x) => `<p>${x}</p>`)
                .join('');
        this.poll = response.data;
      });
    },
    startPoll() {
      var alertOptions = {
        title: 'Подтверждение',
        text: 'Здесь вы можете пройти онлайн-версию опросника MCHAT-R, который позволяет определить риск аутизма у ребенка в возрасте 16-30 месяцев. Вы даете свое согласие на проведение анкетирования?',
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        showCancelButton: true,
        icon: 'warning',
      };
      Constants.alert.fire(alertOptions).then((res) => {
        if (res.isConfirmed) {
          if (this.poll && this.poll.items) {
            this.currentQuestion = 0;
            this.state = 2;
            this.answers = {dateStart: this.poll.dateCreate, answerYesIds: []};
          }
        }
      });
    },
    prevQuestion() {
      if (this.currentQuestion > 0)
        this.currentQuestion--;
    },
    exit() {
      var alertOptions = {
        title: 'Подтверждение',
        text: 'Вы уверены, что хотите завершить опрос? Все данные будут потеряны',
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        showCancelButton: true,
        icon: 'warning',
      };
      Constants.alert.fire(alertOptions).then((res) => {
        if (res.isConfirmed) {
          this.state = 1;
        }
      });
    },
    nextQuestion(isTrue) {
      if (isTrue)
        this.answers.answerYesIds.push(this.poll.items[this.currentQuestion].id);
      this.currentQuestion++;
    },
    save() {
      API.savePoll(this.answers).then(response => {
        this.state = 3;
        this.result = response.data;
        this.item.uid = this.result.uid;
      });
    },
    loadRelationTypeList() {
      API.getRelationTypeList().then(response => {
        this.relationTypeList = response.data;
        // this.item.tmpRepresentatives[0].relationTypeId = this.relationTypeList[0].id;

        //console.log(this.relationTypeList, "------------ loadRelationTypeList");
      });
    },
    loadDistrictList() {
      API.getDistrictList().then(response => {
        //this.districtList = response.data;
        if (response.data && response.data.length) {
          response.data.forEach((i) => this.districtList.push(i));
        }
      });
    },
    saveTmpPatient() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }


      API.saveTmpPatient(this.item).then((response) => {
        const msg = 'Данные успешно отправлены в АИС РМЛ РАС. Специалист свяжется с Вами по указанному номеру телефона в ближайшее время для помощи и определения порядка дальнейшего взаимодействия.'
        Constants.alert.fire('Сохранение', response.data.success ? msg : response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          //this.item = {tmpRepresentatives: []};
          this.state = 4;
        }
      });
    },
    addRepres() {
      this.item.tmpRepresentatives.push({relationTypeId: this.relationTypeList[0].id});
    },
    deleteRepres(el) {
      this.item.tmpRepresentatives.splice(
          this.item.tmpRepresentatives.indexOf(el),
          1
      );
    },
    loadResultFile() {
      API.exportFile(this.result.uid)
    },
    detailInfo() {
      this.isShowDetail=true;
    },
    doctorFind() {
      if(this.state != 4) {
        this.detailInfo();
        Constants.alert.fire('Ошибка', 'Для записи к врачу необходимо заполнить следующую форму', 'error');
        return;
      }

      this.isShowDoctorFind = true;
    }
  },
  computed: {
    isHighRisk() {
      return this.result.numberOfPoints >= 8;
    },
    isMidRisk() {
      return this.result.numberOfPoints > 2 && this.result.numberOfPoints < 8;
    },
    isLowRisk() {
      return this.result.numberOfPoints <= 2;
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        isAgree: {chbxChecked},
        // surname: {required, maxLength: maxLength(50)},
        // name: {required, maxLength: maxLength(50)},
        // patronimic: {maxLength: maxLength(50)},
        // dateOfBirth: {required},
        // created: {required},
        addressDistrictId: { requiredValidator }
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "src/assets/theme/default/colors";

.questions {
  margin-top: 2rem;
  max-width: 1312px;
  width: 100%;
  padding: 24px;
  content: "";
  height: 100%;
  min-height: 254px;
  overflow: auto;
  top: 50%;
  left: 50%;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  background-color: #fff;

}

.content-data {
  height: 100%;
}

.form-group--border {
  margin: 10px;
  padding: 10px;
  border: solid 1px #eee;
}

.form-check.required .control-label:after {
  content: "*";
  color: red;
}

.form-group.required .control-label:after {
  content: "*";
  color: red;
}

.invalid-msg {
  color: red;
  font-size: 0.75rem;
}

.button-component {
  min-width: 100px;
  display: block;
}

.btn {
  max-width: 180px;
}

.control-label {
  font-weight: 400 !important;
  color: $gray-dark;
  font-size: 16px;
}

@media (max-width: 574px) {
  .button-component {
    max-width: 100%;
    min-width: 100%;
    width: 100%;
  }
}

.select2::v-deep {
  .select2-container {
    width: 100% !important;
    max-width: 100% !important;

    .select2-selection__rendered {
      line-height: 32px;
    }
  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 7px !important;
  }
}
.mr-2 {
  margin-right: 10px;
}

</style>